import React from 'react';
import JumboNavIdentifier from "@jumbo/components/JumboVerticalNavbar/JumboNavIdentifier";
import useJumboLayoutSidebar from "@jumbo/hooks/useJumboLayoutSidebar";
import {SIDEBAR_VIEWS} from "@jumbo/utils/constants/layout";
import List from "@mui/material/List";
import PropTypes from 'prop-types';
import { FiLogOut } from "react-icons/fi";
import { logoutAction } from 'app/redux/actions/authAction';

const JumboVerticalNavbar = ({items}) => {

    const onLogout = () => {
        logoutAction();
        window.location.reload(false);
    };
    const {sidebarOptions} = useJumboLayoutSidebar();

    const isMiniAndClosed = React.useMemo(() => {
        return sidebarOptions?.view === SIDEBAR_VIEWS.MINI && !sidebarOptions?.open;
    }, [sidebarOptions.view, sidebarOptions.open]);

    return (
        <>
       
        <List 
       
            disablePadding
            sx={{
                mr: isMiniAndClosed ? 0 : 0,
                pb: 2,
                fontSize:"19px",
                fontWeight:"600",
                mt: 2
            }}
        >
            {
                items.map((item, index) => (
                    <JumboNavIdentifier translate item={item} key={index} />
                ))
            }
        </List>
        <div className='logout'onClick={onLogout}>
            <FiLogOut className='logout_icon' />
            <h3>Logout</h3>
            


        </div>
       

        </>
    );
};

JumboVerticalNavbar.defaultProps = {
    items: PropTypes.array,
    translate: false
};

export default JumboVerticalNavbar;